exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hidetable[data-v-d0171b04]{\n\ttable-layout:fixed;\n\tbackground-color: #ffffff;\n\tborder-collapse: collapse;\n\tborder: 0px solid black;\n\tempty-cells: show;\n}\n.hidetabledynamic[data-v-d0171b04]{\n\tbackground-color: #ffffff;\n\tborder-collapse: collapse;\n\tborder: 0px solid black;\n\tempty-cells: show;\n}\n.employeebox[data-v-d0171b04]{\n\tfloat:left;\n\tmargin:1px;\n\theight:30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d0171b04","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/layout_4.vue
// module id = 761
// module chunks = 0